'use client';

import { LotteryInfiniteList as CommonLotteryInfiniteList } from '@monorepo/common';
import type { LotteryInfiniteListProps } from '@monorepo/common';
import { getLotteryEvent } from '../../api/getLotteryEvent';
import LotteryEventList from '../LotteryEventList/LotteryEventList';

function LotteryInfiniteList({
  lotteryEventList,
  pageLimit,
  query,
  tagId,
  requestTime,
  tab,
}: Omit<LotteryInfiniteListProps, 'getLotteryEventFunction' | 'LotteryEventListComponent' | 'isSession'>) {
  return (
    <CommonLotteryInfiniteList
      lotteryEventList={lotteryEventList}
      pageLimit={pageLimit}
      query={query}
      tagId={tagId}
      requestTime={requestTime}
      tab={tab}
      getLotteryEventFunction={getLotteryEvent}
      LotteryEventListComponent={LotteryEventList}
    />
  );
}

export default LotteryInfiniteList;
